import appStore from 'store';
import api from './api';
import { STATUS_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    audistCount: 0,
    pagination: { page: 1, size: 25 },
    activeTab: 'all'
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.slice().map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status]
        };
      });
    },
    setAudistCount(state, payload) {
      state.audistCount = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    }
  },
  actions: {
    // eslint-disable-next-line
    approve({ commit }, data) {
      return new Promise(resolve => {
        api.approveAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    reject(context, data) {
      return api.rejectAudit(data);
    },
    getAllList({ commit }, query) {
      api.getAllList(query).then(({ data }) => {
        commit('setAuditList', data.list || []);
        commit('setAudistCount', data.totalCount || 0);
        commit('setPagination', { page: query.page, size: query.size });
      });
    },
    cancelOrder(context, data) {
      return api.cancelOrder(data);
    },
    gaveMoney(context, data) {
      return api.gaveMoney(data);
    },
    receivedMoney(context, data) {
      return api.receivedMoney(data);
    }
  }
};

appStore.registerModule('c2call', store);
